import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function LoginPage({ mode = "login" }) {
  const { login, register } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (mode === "register") await register(email, password, name);
      else await login(email, password);
      nav("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Authentication failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-navy flex">
      <div className="hidden lg:flex flex-1 flex-col justify-between p-16 text-ivory relative overflow-hidden">
        <div className="absolute inset-0 grain opacity-30" />
        <div className="relative flex items-center gap-4">
          <img src="/brand/logo.png" alt="Goldline" className="w-14 h-14 object-contain" />
          <div>
            <div className="eyebrow text-gold">Goldline Advisory Co.</div>
            <div className="w-12 h-[2px] bg-gold mt-3" />
          </div>
        </div>
        <div className="relative">
          <h1 className="font-display text-6xl leading-tight mb-6 text-ivory">
            Consulting-grade<br />AI assessments,<br /><span className="text-gold italic">in minutes.</span>
          </h1>
          <p className="text-ivory/70 text-lg max-w-md">
            Conduct a structured interview, let Claude analyze the pain points, and walk out with a branded
            PowerPoint your clients will sign off on.
          </p>
        </div>
        <div className="relative eyebrow text-ivory/40">Private · For Consultant Use</div>
      </div>

      <div className="flex-1 flex items-center justify-center p-8 bg-ivory grain">
        <div className="w-full max-w-md">
          <div className="mb-10">
            <div className="eyebrow text-gold">{mode === "register" ? "Create Account" : "Sign In"}</div>
            <h2 className="font-display text-4xl text-navy mt-3">{mode === "register" ? "Start your practice" : "Welcome back"}</h2>
            <div className="w-10 h-[2px] bg-gold mt-4" />
          </div>

          <form onSubmit={submit} className="space-y-5" data-testid="auth-form">
            {mode === "register" && (
              <div>
                <Label htmlFor="name" className="text-navy">Your name</Label>
                <Input id="name" data-testid="name-input" value={name} onChange={(e) => setName(e.target.value)} required className="mt-2 h-11 bg-white border-navy/20 rounded-none" />
              </div>
            )}
            <div>
              <Label htmlFor="email" className="text-navy">Email</Label>
              <Input id="email" data-testid="email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-2 h-11 bg-white border-navy/20 rounded-none" />
            </div>
            <div>
              <Label htmlFor="password" className="text-navy">Password</Label>
              <Input id="password" data-testid="password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-2 h-11 bg-white border-navy/20 rounded-none" />
            </div>
            <Button type="submit" disabled={loading} data-testid="submit-auth-btn"
              className="w-full h-12 bg-navy hover:bg-navy/90 text-ivory rounded-none font-medium tracking-wide">
              {loading ? "Please wait..." : mode === "register" ? "Create Account" : "Sign In"}
            </Button>
          </form>

          <div className="mt-8 text-sm text-navy/60">
            Accounts are invite-only. Contact your administrator if you need access.
          </div>
        </div>
      </div>
    </div>
  );
}
